module.exports = __webpack_public_path__ + "media/images/plan-detail__image-3@2x-7622475882d15f70521669e82716903b.jpg";